import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Leaf } from "lucide-react";
import Logo from "./Logo";
import { COMPANY, SERVICES, mailLink } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-navy text-white relative grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-5">
            <Logo variant="light" />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Installation, dépannage et maintenance de vos systèmes énergétiques à {COMPANY.area}.
            </p>
            <div className="flex items-center gap-2 text-brand text-sm font-semibold">
              <Leaf className="w-4 h-4" /> Vers une énergie plus performante
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-5">Services</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="hover:text-brand transition-colors">{s.title}</Link>
                </li>
              ))}
              <li><Link to="/depannage-urgence" className="hover:text-brand transition-colors">Dépannage d'urgence</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-5">Navigation</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              <li><Link to="/" className="hover:text-brand transition-colors">Accueil</Link></li>
              <li><Link to="/a-propos" className="hover:text-brand transition-colors">À propos</Link></li>
              <li><Link to="/realisations" className="hover:text-brand transition-colors">Réalisations</Link></li>
              <li><Link to="/devis" className="hover:text-brand transition-colors">Demande de devis</Link></li>
              <li><Link to="/rendez-vous" className="hover:text-brand transition-colors">Prendre rendez-vous</Link></li>
              <li><Link to="/contact" className="hover:text-brand transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-5">Contact</h4>
            <ul className="space-y-4 text-white/70 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-brand mt-0.5 shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-brand">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-brand mt-0.5 shrink-0" />
                <a href={mailLink("Demande via le site MS Énergie")} className="hover:text-brand break-all">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-brand mt-0.5 shrink-0" />
                <span>{COMPANY.address}, {COMPANY.zip} {COMPANY.city}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-brand mt-0.5 shrink-0" />
                <span>{COMPANY.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-white/50 text-sm">
          <p>© {new Date().getFullYear()} MS Énergie — Tous droits réservés.</p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="hover:text-brand transition-colors">Mentions légales</Link>
            <Link to="/admin/login" className="hover:text-brand transition-colors">Espace admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
